"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
const multilingual_type_helper_1 = require("../../../shared/multilingual-type-helper");
const idm_export_templates_service_client_js_1 = require("@synisys/idm-export-templates-service-client-js");
class RichTextState {
    constructor(state, id, title) {
        this.state = state;
        this.id = id;
        this.title = title;
    }
    static fromJSON(jsonObject) {
        const id = jsonObject && jsonObject.componentId || uuid_1.v4();
        const title = jsonObject &&
            multilingual_type_helper_1.MultilingualTypeHelper.deserializeMultilingualString(jsonObject.title) || null;
        let state = RichTextState.stateFromJSON(jsonObject ? jsonObject.state : null);
        return new RichTextState(state, id, title);
    }
    static stateFromJSON(stateJSON) {
        let state = stateJSON ? JSON.parse(stateJSON) : null;
        let uuid = state ? state.uuid : null;
        let htmlTemplate = state ? state.htmlTemplate : null;
        let name = state ? state.name : null;
        let description = state ? state.description : null;
        return new idm_export_templates_service_client_js_1.Template(uuid, null, multilingual_type_helper_1.MultilingualTypeHelper.deserializeMultilingualString(htmlTemplate), multilingual_type_helper_1.MultilingualTypeHelper.deserializeMultilingualString(name), multilingual_type_helper_1.MultilingualTypeHelper.deserializeMultilingualString(description), null, null);
    }
    toJSON() {
        return {
            componentId: this.id,
            title: this.title && multilingual_type_helper_1.MultilingualTypeHelper.serializeMultilingualString(this.title) || null,
            state: this.state && this.state.toJSON()
        };
    }
}
exports.RichTextState = RichTextState;
//# sourceMappingURL=rich-text-state.js.map